import {NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import {CommonModule} from '@angular/common';

import { PulseContentComponent } from 'app/main/content/content.component';
import { authGuard } from '../../core/auth/auth.guard';
import {
    DxButtonModule,
    DxDataGridModule,
    DxFormModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxTabsModule
} from "devextreme-angular";
import {FlexModule} from "@ngbracket/ngx-layout";
import {PulseDirectivesModule} from "../../../@pulse/directives/directives";
import {DxiColumnModule, DxiRowModule} from "devextreme-angular/ui/nested";

const routes: any = [
    {
        path: '',
        redirectTo: '/admin-dashboard',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [authGuard]
    },
    {
        path: '',
        loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
        canActivate: [authGuard]
    },
    {
        path: 'payroll',
        loadChildren: () => import('./payroll/payroll.module').then(m => m.PayrollModule),
        canActivate: [authGuard]
    },
    {
        path: 'update-qb-status',
        loadChildren: () => import('./payroll-qb/payroll-qb.module').then(m => m.PayrollQbModule),
        canActivate: [authGuard]
    },
    {
        path: 'sync-candidate',
        loadChildren: () => import('./sync-candidate/sync-candidate.module').then(m => m.SyncCandidateModule),
        canActivate: [authGuard]
    },
    {
        path: 'payroll-qb',
        loadChildren: () => import('./update-qb-status/update-qb-status.module').then(m => m.UpdateQbStatusModule),
        canActivate: [authGuard]
    },
    {
        path: 'calculator',
        loadChildren: () => import('./calculator/calculator.module').then(m => m.CalculatorModule),
        canActivate: [authGuard]
    },
    {
        path: 'audit-trail',
        loadChildren: () => import('./audit-trail/audit-trail.module').then(m => m.AuditTrailModule),
        canActivate: [authGuard]
    },
    {
        path: 'candidate-digital-attestation',
        loadChildren: () => import('./candidate-digital-attestion/candidate-digital-attestion.module').then(m => m.CandidateDigitalAttestionModule)
    },
    {
        path: 'linkify-new',
        loadChildren: () => import('./linkify/linkify.module').then(m => m.LinkifyModule),
    },
    {
        path: 'company-snapshot-report',
        loadChildren: () => import('./company-snapshot/company-snapshot.module').then(m => m.CompanySnapshotModule),
        canActivate: [authGuard]
    },
    {
        path: 'invoice',
        loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule),
        canActivate: [authGuard]
    },
    {
        path: 'linkify',
        loadChildren: () => import('./linkedin-search/linkedin-search.module').then(m => m.LinkedinSearchModule)
    },
    {
        path: 'zeal-sync',
        loadChildren: () => import('./terminated-consultant/terminated-consultant.module').then(m => m.TerminatedConsultantModule),
        canActivate: [authGuard]
    },
    {
        path: '',
        loadChildren: () => import('./rbac/rbac.module').then(m => m.RbacModule),
        canActivate: [authGuard]
    },
    {
        path: 'automations',
        loadChildren: () => import('./automations/automations.module').then(m => m.AutomationsModule),
        canActivate: [authGuard]
    },
    {
        path: 'touchpoint',
        loadChildren: () => import('./touch-point/touch-point.module').then(m => m.TouchPointModule),
        canActivate: [authGuard]
    },
    {
        path: 'qcomm',
        loadChildren: () => import('./qcomm/qcomm.module').then(m => m.QcommModule),
        canActivate: [authGuard]
    },
    {
        path: 'five-percentile',
        loadChildren: () => import('./five-percentile/five-percentile.module').then(m => m.FivePercentileModule),
    },
    {
        path: '',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canActivate: [authGuard]
    },
    {
        path: '',
        loadChildren: () => import('./user/user.module').then(m => m.UserModule),
        canActivate: [authGuard]
    },
];


@NgModule({
    declarations: [
        PulseContentComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        DxButtonModule,
        DxFormModule,
        FlexModule,
        DxSelectBoxModule,
        DxTabsModule,
        PulseDirectivesModule,
        DxiColumnModule,
        DxDataGridModule,
        DxLoadPanelModule,
        DxiRowModule
    ],
    exports: [
        PulseContentComponent
    ]
})

export class PulseContentModule {
}
